import React from "react";
import PropTypes from "prop-types";
import SimpleVirtualizedAutocomplete from "../../../../../../../../components/Dropdown/SimpleVirtualizedAutocomplete";
import { VIEW_COLUMNS } from "../../../../config/deviceColumnsConfig";

const AddDeviceRow = ({
  deviceOptions,
  addDevice,
  newDeviceId,
  setNewDeviceId,
}) => {
  const handleOnChange = (event, newValue) => {
    if (newValue) {
      setNewDeviceId(newValue.deviceId);
      addDevice(newValue.deviceId);
      setNewDeviceId(""); // Clear selection after adding.
    } else {
      setNewDeviceId("");
    }
  };

  return (
    <tr className="hover:bg-cyan-50 hover:shadow-md">
      <td className="px-2 py-1 border-b border-white text-center bg-white" />
      <td colSpan={VIEW_COLUMNS.length} className="border">
        <SimpleVirtualizedAutocomplete
          options={deviceOptions}
          value={
            deviceOptions.find((option) => option.deviceId === newDeviceId) ||
            null
          }
          onChange={handleOnChange}
          optionKey="deviceId"
          optionLabel="deviceName"
          placeholder="Select a device..."
          itemSize={40}
          maxVisibleItems={8}
          className="w-full py-1 px-2"
        />
      </td>
    </tr>
  );
};

AddDeviceRow.propTypes = {
  deviceOptions: PropTypes.array.isRequired,
  addDevice: PropTypes.func.isRequired,
  newDeviceId: PropTypes.string.isRequired,
  setNewDeviceId: PropTypes.func.isRequired,
};

export default AddDeviceRow;
